<template>
  <v-app>
   <v-navigation-drawer
      v-if="userIsAdmin()"
      fixed
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      v-model="drawer"
      v-on:input="drawerStatusCatch"
      >
     <app-menu></app-menu>  
    </v-navigation-drawer>
    <app-toolbar :drawer="drawer" v-on:drawerStatus="drawerStatusCatch"></app-toolbar>
    <v-content>
      <keep-alive>
        <router-view :key="$route.path"></router-view>
      </keep-alive> 
    </v-content>
    <app-notification></app-notification>
  </v-app>
</template>

<script>
import menu from './components/layout/Menu'
import toolbar from './components/layout/ToolBar'
import notification from './components/shared/notification'

export default {
  // mounted: {
  // },
  data () {
    return {
      show: false,
      dialog: false,
      drawer: null,
      bottomNav: 3
    }
  },
  methods: {
    drawerStatusCatch (status) {
      this.drawer = status
    }
  },
  props: {
    source: String
  },
  components: {
    'app-menu': menu,
    'app-toolbar': toolbar,
    'app-notification': notification
  }
}
</script>

<style>
h1 {
  color: #bacf19;
  margin: 0px 0 0px 0;
  font-size: 32px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}
h2 {
  color: #bacf19;
  margin: 0px 0 0px 0;
  font-size: 28px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}
h3 {
  color: #bacf19;
  margin: 0px 0 0px 0;
  font-size: 22px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}
h4 {
  color: #bacf19;
  margin: 0px 0 0px 0;
  font-size: 18px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}
.pf-padding {
  padding: 20px 0;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-leave, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(0px);
  opacity: 0;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-64px);
  opacity: 100;
}
a h3.headline {
  text-decoration:  none;
}
a, a:link{
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?8cd84178